(function () {
  'use strict';

  var SHOW_DELAY = 150;
  var HIDE_DELAY = 200;
  var BREAKPOINT = 990;

  function getHeaderBottom() {
    var header = document.querySelector('.header-wrapper') || document.querySelector('header');
    return header ? Math.round(header.getBoundingClientRect().bottom) : 0;
  }

  function init() {
    if (window.innerWidth < BREAKPOINT) return;

    var megaSection = document.querySelector('.mimeraki-mega-menu');
    var customPanels = megaSection
      ? Array.from(megaSection.querySelectorAll('[data-mega-panel]'))
      : [];
    var allDetails = Array.from(document.querySelectorAll('details[data-mega-trigger]'));

    function positionCustomPanels() {
      var top = getHeaderBottom();
      customPanels.forEach(function (p) { p.style.top = top + 'px'; });
    }

    function hideAllCustom() {
      customPanels.forEach(function (p) { p.classList.remove('is-visible'); });
    }

    function hideAllNative() {
      allDetails.forEach(function (d) { d.open = false; });
    }

    function hideAll() {
      hideAllCustom();
      hideAllNative();
    }

    if (customPanels.length) {
      customPanels.forEach(function (p) { p.removeAttribute('hidden'); });
      positionCustomPanels();
    }

    allDetails.forEach(function (details) {
      var handle = details.dataset.megaTrigger;
      var customPanel = megaSection
        ? megaSection.querySelector('[data-mega-panel="' + handle + '"]')
        : null;
      var nativeContent = details.querySelector('.mega-menu__content');
      var summary = details.querySelector('summary');

      var showTimer = null;
      var hideTimer = null;

      // Suppress click on all desktop items — hover takes over
      if (summary) {
        summary.addEventListener('click', function (e) {
          if (window.innerWidth >= BREAKPOINT) {
            e.preventDefault();
            e.stopPropagation();
          }
        });
      }

      function scheduleShow() {
        clearTimeout(hideTimer);
        showTimer = setTimeout(function () {
          hideAll();
          if (customPanel) {
            customPanel.classList.add('is-visible');
          } else {
            details.open = true;
          }
          document.dispatchEvent(new CustomEvent('mega-menu-opened'));
        }, SHOW_DELAY);
      }

      function scheduleHide() {
        clearTimeout(showTimer);
        hideTimer = setTimeout(function () {
          if (customPanel) {
            customPanel.classList.remove('is-visible');
          } else {
            details.open = false;
          }
          // Solo disparar closed si no queda ningún panel abierto
          var anyOpen = customPanels.some(function (p) { return p.classList.contains('is-visible'); }) ||
                        allDetails.some(function (d) { return d.open; });
          if (!anyOpen) {
            document.dispatchEvent(new CustomEvent('mega-menu-closed'));
          }
        }, HIDE_DELAY);
      }

      function cancelHide() {
        clearTimeout(hideTimer);
      }

      details.addEventListener('mouseenter', scheduleShow);
      details.addEventListener('mouseleave', scheduleHide);

      if (customPanel) {
        customPanel.addEventListener('mouseenter', cancelHide);
        customPanel.addEventListener('mouseleave', scheduleHide);
      } else if (nativeContent) {
        nativeContent.addEventListener('mouseenter', cancelHide);
        nativeContent.addEventListener('mouseleave', scheduleHide);
      }
    });

    // Close everything on outside click
    document.addEventListener('click', function (e) {
      if (!e.target.closest('details[data-mega-trigger]') &&
          !e.target.closest('[data-mega-panel]')) {
        hideAll();
      }
    });

    // Resize: close or reposition
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (window.innerWidth < BREAKPOINT) {
          hideAll();
        } else if (customPanels.length) {
          positionCustomPanels();
        }
      }, 100);
    });

    // Scroll: reposition fixed custom panels
    if (customPanels.length) {
      window.addEventListener('scroll', function () {
        positionCustomPanels();
      }, { passive: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
